<template>
	<div>
		<div class="mb-4 header">
			<div v-if="pictureUrl" class="picture-container">
				<img :src="pictureUrl" />
			</div>
			<p v-html="questionHtml" />
			<p class="note" v-if="note">{{ note }}</p>
		</div>

		<div class="answer-container">
			<question-answer
					v-for="(answer, i) in answers"

					:key="i"

					:guid="answer.guid"
					:answer-html="answer.answerHtml"
					:is-correct="answer.isCorrect"
					:show-result="showResult"

					:checked="selectedAnswerIndexes.includes(i)"
					v-on:click.native="toggleAnswer(i)"

					:class="canAnswer ? 'can-answer' : 'cannot-answer'"
			/>
		</div>
	</div>
</template>

<script>
	import QuestionAnswer from './QuestionAnswer';

	export default {
		name: 'question',
		components: {
			QuestionAnswer
		},
		props: {
			guid: {
				type: String
			},
			questionHtml: {
				type: String
			},
			answers: {
				type: Array
			},
			note: {
				type: String,
				required: false
			},
			explanation: {
				type: String,
				required: false
			},
			pictureUrl: {
				type: String,
				required: false
			},
			pictureText: {
				type: String,
				required: false
			},
			type: {
				type: String
			},
			canAnswer: {
				type: Boolean
			},
			showResult: {
				type: Boolean,
			},
		},
		data() {
			return {
				selectedAnswerIndexes: [],
			};
		},
		watch: {
			guid() {
				console.log('new guid!');
				this.reset();
			},
			selectedAnswerIndexes(value) {
				this.$emit('selectedAnswerIndexesChanged', value);
			}
		},
		mounted() {
			this.reset();
		},
		methods: {
			toggleAnswer(i) {
				if (this.selectedAnswerIndexes.includes(i)) {
					this.selectedAnswerIndexes = this.selectedAnswerIndexes.filter(v => v !== i);
				} else {
					this.selectedAnswerIndexes.push(i)
				}
			},
			nextQuestion() {
				this.$emit('nextQuestion');
			},
			reset() {
				this.selectedAnswerIndexes = [];
			},
		}
	}
</script>

<style lang="scss" scoped>
	.answer-container {
		margin-bottom: 40px;
	}

	.note {
		font-style: italic;
		font-size: 10pt;

		&:before {
			content: "(";
		}

		&:after {
			content: ")";
		}
	}

	.header {
		p {
			margin-bottom: 0;
		}
	}

	.picture-container {
		max-width: 100%;

		img {
			max-width: 100%;
			max-height: 400px;
			margin: 0 auto;
		}
	}
</style>
